import React from 'react';
import PropTypes from 'prop-types';
import CardWithIcon from '../card-with-icon/index';
import { Container } from '../styled/containers';
import WebchatCardWithIconDecorated from '../webchat/card-with-icon';

// Styles
import { CardRow } from './styles';
import { useLayout } from '../layout/context';

const CardsWithIcons = ({ cards }) => {
  const { insideContainer } = useLayout();

  return (
    <Container $padding={!insideContainer}>
      <CardRow $cardsCount={cards.length}>
        {cards &&
          cards.map((card, i) =>
            card.cardType === 'Webchat' ? (
              <WebchatCardWithIconDecorated key={i} {...card} />
            ) : (
              <CardWithIcon key={i} {...card} />
            )
          )}
      </CardRow>
    </Container>
  );
};

CardsWithIcons.propTypes = {
  cards: PropTypes.arrayOf(PropTypes.shape(CardWithIcon.propTypes)).isRequired,
};

export default CardsWithIcons;
